import './org.commands'
import OrgsView from '@/tenants/OrgsView.vue'
import {patronUrl} from '@/services/infrastructure/patron.service'
import {registerRoute} from '@/router'
import {useContaCommand} from '@/commandbar/commandBar.service'
import {registerHotkey} from '@/hotkeys/navigationHotkeys'
import {useBreadCrumbs} from '@/breadcrumbs/useBreadCrumbs'
import {NavGroup, registerNavigationEntry} from '@/navigation'

const {registerNavigationCommand} = useContaCommand()
const {buildSimpleCrumb} = useBreadCrumbs()


export const REGISTER_ORG = patronUrl + '/register-organization'
export const ORGS = {componentName: 'Orgs', component: OrgsView, meta: {requiresOrg: false}}

const hotkey = 'x'
registerRoute(ORGS)
const label = 'Virksomheter'
const icon = 'i-ph-buildings-fill'
registerNavigationCommand({
    route: ORGS,
    label,
    icon,
    hotkey
})
registerNavigationEntry(NavGroup.START, {
    title: label,
    key: 'orgs',
    icon,
    target: ORGS
})
registerHotkey(hotkey, ORGS)
buildSimpleCrumb(ORGS, label, icon)